import { render, staticRenderFns } from "./PropertyIdentifier.vue?vue&type=template&id=afd39584&scoped=true"
import script from "./PropertyIdentifier.vue?vue&type=script&lang=js"
export * from "./PropertyIdentifier.vue?vue&type=script&lang=js"
import style0 from "./PropertyIdentifier.vue?vue&type=style&index=0&id=afd39584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd39584",
  null
  
)

export default component.exports